// extracted by mini-css-extract-plugin
export default {"otp-verification-form":"OTPVerificationForm_otp-verification-form__XGx7K","input-style":"OTPVerificationForm_input-style__t7T18","btn-style":"OTPVerificationForm_btn-style__YEyPR"};